










import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class TopNav extends Vue {
  @Prop() private title!: string[];
}
